import React from "react";
import { Switch, Route } from "react-router-dom";
import AccountantsReport from "./AccountantsReport";
import "../css/exportWrapper.scss";
import Export from "./Export";

const ExportWrapper = () => {
  return (
    <div className="exportWrapperPage">
      {/* <div className="exportTypeBar">
        <NavLink activeClassName="activeLink" to="/export/access">
          access
        </NavLink>
        <NavLink activeClassName="activeLink" to="/export/accounts">
          accounts
        </NavLink>
      </div> */}

      <Switch>
        <Route path="/settings/export/access">
          <Export />
        </Route>
        <Route path="/settings/export/accounts">
          <AccountantsReport />
        </Route>
        <Route exact path="/settings/export">
          {/* <Export /> */}
          <AccountantsReport />
        </Route>
      </Switch>
    </div>
  );
};

export default ExportWrapper;
